module.exports = __webpack_public_path__ + "static/img/bg-blue.8a338dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bg-blue.png
// module id = mLdz
// module chunks = 62